import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { CheckboxComponent, IconHelpComponent, RtTooltip } from '@recruitee/user-interface';

import { DynamicHelpers } from '../../helpers';
import { DynamicCheckboxInputConfig } from '../../types';
import { DynamicFormInput } from '../dynamic-form/dynamic-form-input/dynamic-form-input';

export class CheckboxInput extends DynamicFormInput<DynamicCheckboxInputConfig> {
  constructor(public config: DynamicCheckboxInputConfig) {
    super({ ...config, value: !!config.value });
  }
}

@Component({
  selector: 'rti-checkbox-input',
  templateUrl: './checkbox-input.component.html',
  styleUrls: ['./checkbox-input.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, CheckboxComponent, IconHelpComponent, RtTooltip],
})
export class CheckboxInputComponent {
  @Input() public input: CheckboxInput;

  constructor(public helpers: DynamicHelpers) {}

  public toggle(): void {
    if (!this.input.config.disabled) {
      this.input.control.setValue(!this.input.control.value);
    }
  }
}
